import { getContentfulLocale } from '../../../../features/src/i18n/locales/index';

/**
 * Validation logic extracted from itemToSearchHit to filter out invalid items
 * including circular references, missing required fields, and unreleased content
 */
export function isValidGridItem(item: any, locale: string): boolean {
  // Check for circular references (these don't have the required fields)
  if (item?.sys?.circular) {
    return false;
  }

  // Check for required content type
  const ctype = item?.contentType as string;
  if (!ctype) {
    return false;
  }

  // Check for required ID
  if (!item?.id) {
    return false;
  }

  // Check for required URL (either urlSlug or url)
  if (!(item?.urlSlug || item?.url)) {
    return false;
  }

  // Check if content is released (skip future release dates)
  if (item?.releaseDate && Date.parse(item.releaseDate) > Date.now()) {
    return false;
  }

  // Check locale validity (similar to itemToSearchHit logic)
  if (locale !== 'en') {
    const isValidForLocale =
      item.contentType === 'customGridContent' ||
      item.translated === true ||
      item.languages?.split(',').indexOf(getContentfulLocale(locale)) >= 0;

    if (!isValidForLocale) {
      return false;
    }
  }

  return true;
}
